window.addEventListener('DOMContentLoaded', () => {
  if (document.querySelectorAll('.form-select:not(.selectchoices-autocomplete):not(.selectchoices-remote)').length) {
    import('./_choices.js').then((module) => {
      module.Init();
    });
  }
});

export default {};
